import * as React from 'react';
import { navigate } from 'router';
import { connect } from 'react-redux';
import { createRouteNodeSelector } from 'redux-router5';
import { downloadCsvReport } from '~/apps/shared/services/transactions';

import { parseTransactionFilter, transactionFilterParams } from '~/apps/shared/services/qsfilter';

import CurrentOrgInjector from '~/apps/shared/containers/app/CurrentOrgInjector';
import TransactionHeaderComp from '~/apps/shared/containers/transactions/TransactionHeader';


const TransactionHeader = (props) => {
  const { route: { params }, auth: { currentUser } } = props;
  const filter = parseTransactionFilter(params);

  return (
    <CurrentOrgInjector
      component={TransactionHeaderComp}
      title="Balance"
      filter={filter}
      onSearch={(q) => {
        filter.q = q;
        navigate('sender.transactions', transactionFilterParams(filter));
      }}
      onExport={(dtStart, dtEnd) => {
        downloadCsvReport(currentUser.organizationId, dtStart, dtEnd);
      }}
    />
  );
};

const mapStateToProps = (state) => {
  const routeNodeSelector = createRouteNodeSelector('sender');

  return {
    auth: state.shared.auth,
    ...routeNodeSelector(state),
  };
};

export default connect(mapStateToProps)(TransactionHeader);
